import { Component, OnInit } from '@angular/core';
import { Edit, LucideAngularModule, Plus } from 'lucide-angular';
import { RouteParams } from '@app/shared/abstract/route-params';
import { SupplierService } from '../shared/supplier.service';
import { SupplierModel } from '../shared/supplier.model';
import { DataTableComponent } from '@app/partials/datatable/data-table/data-table.component';
import { FormsModule } from '@angular/forms';
import { Destroyer } from '@app/shared/abstract/destroyer';
import { PagedEntities } from '@app/shared/abstract/paged-entities';
import { Column } from '@app/partials/datatable/data-table/column';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-index11',
  imports: [LucideAngularModule, DataTableComponent, FormsModule, RouterLink],
  templateUrl: './suppliers-index.component.html',
  styleUrl: './suppliers-index.component.css',
})
export class SuppliersIndexComponent extends Destroyer implements OnInit {
  protected readonly PlusIcon = Plus;
  protected readonly EditIcon = Edit;

  protected suppliersPage?: PagedEntities<SupplierModel>;
  // protected categoriesControl = new FormControl();

  routeParams = new RouteParams({
    pageNum: 1,
    pageSize: 100,
  });

  tableColumns: Column<SupplierModel>[] = [
    // { field: 'id', header: 'Id' },
    { field: 'image_1_sm', header: 'Picture', type: 'image' },
    {
      field: 'self',
      callback: (row) => {
        return row.services?.map((service) => service.name).join(', ');
      },
      header: 'Services',
    },
    { field: 'name', header: 'Name', sortable: true },
  ];

  rowActions = [
    {
      icon: this.EditIcon,
      type: 'link',
      routerLink: (item: SupplierModel) => ['/suppliers', item.id, 'edit'],
    },
  ];

  constructor(private service: SupplierService) {
    super();
  }

  loadData() {
    this.service.getPage(this.routeParams).subscribe((res) => {
      this.suppliersPage = res;
    });
  }

  ngOnInit(): void {
    this.loadData();
    //
    // this.categoriesControl.valueChanges.pipe(takeUntil(this.destroy$)).subscribe((value) => {
    //   this.routeParams.filter = value ? [{ field: 'category', value: value.join(',') }] : [];
    //   this.loadData();
    // });
  }

  handleRoute(sorts: RouteParams) {
    this.routeParams.sort = sorts.sort;
    this.routeParams.pageNum = sorts.pageNum;
    this.routeParams.pageSize = sorts.pageSize;
    this.loadData();
  }
}
